import ErrorContent from '@/pages/Errors/components/ErrorContent';
import {useOktaAuth} from '@okta/okta-react';
import {useState} from 'react';
import PropTypes from 'prop-types';

export const PageError403 = ({error}) => {
  const [isLoading, setIsLoading] = useState(false);
  const {oktaAuth} = useOktaAuth();

  const onClickReturn = () => {
    setIsLoading(true);
    oktaAuth.signOut();
  };

  return (
    <>
      <p className='mt-4 w-full text-center'>{error?.message}</p>
      <ErrorContent
        errorType='FORBIDDEN'
        isLoading={isLoading}
        onClick={onClickReturn}
      />
    </>
  );
};

PageError403.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string
  })
};

PageError403.defaultProps = {
  error: null
};
